import {
	SET_FORM_STATE,
	GET_REPOSITORY_FILES,
	TOGGLE_REMOVE_REPOSITORY_FILE_DIALOG,
	GET_PDF_IMFORMATION
} from '../actions/RepositoryPdfActions';

const initialState = {
	filesInfo: [],
	removeRepoFileDialogVisibility: false,
	pdfInformationBase64: '',
	formState: {
		values: {
			repositoryPdfInputFilePath: ''
		},
		isValid: false,
		touched: {},
		errors: {},
	},
};

const repositoryPdfReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_REPOSITORY_FILES: {
						return {
							...state,
							filesInfo: action.filesInfo
						};
					}
					case TOGGLE_REMOVE_REPOSITORY_FILE_DIALOG: {
						return {
							...state,
							removeRepoFileDialogVisibility: action.visible,
							tableId: action.tableId,
							filename: action.filename,
							stream: action.stream
						};
					}
					case GET_PDF_IMFORMATION: {
						return {
							...state,
							pdfInformationBase64: action.pdfInformationBase64,
						};
					}
					default: {
						return state;
					}
	}
};

export default repositoryPdfReducer;
